import React, { forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//horizontalScroll
import ScrollContainer from 'react-indiana-drag-scroll';
//select
import SelectSearch from 'react-select-search';
import 'src/asset/scss/plugin/select.scss';
//styles
import styles from 'src/asset/scss/styles/userPartnerItemReg.module.scss';
//hooks
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
import useUploadFileHook from 'src/webapp/hooks/comn/uploadFile.hook';
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//store
import useAdminStore from 'src/webapp/stores/admin.store';
//CompWrapper
import Element from 'src/webapp/views/wrapper/Element';
import FormWrapper from 'src/webapp/views/wrapper/form/Form';//입력폼
import TitleWrapper from 'src/webapp/views/wrapper/form/Title';//입력폼내제목
//comp
import ImgArea from 'src/webapp/views/component/ImgArea';//상품이미지
import Button from 'src/webapp/views/component/Button';//버튼엘리먼트
import VehicleListPopup from '../popup/VehicleList';//팝업-등록차량선택

const Form = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({//상위컴포넌트에서 호출
        onSubmitHandler
    }));
    const params = useParams();//queryParameter
    const navigator = useNavigate();
    const { data, type, priceGroupList } = props;//props
    const inputRef = useRef([]);//입력값
    //hook
    //파일추가
    const { comnListAPI//공통코드호출API
        , comnList//공통코드
        , onNumberCommaHandler//세자리콤마핸들러
        , removeCommaHandler//콤마제거 및 타입변환
        , onDecimalCommaHandler//소수점세자리콤마핸들러
        , setOnMessageHandler
    } = useComnHook();
    //파일추가
    const { files, setFiles//fileuseState
        , MAX_COUNT//최대업로드갯수
        , addFilesHandler//파일업로드핸들러
    } = useUploadFileHook();
    const { axiosMultiPartHandler, axiosPostHandler } = useAxiosHook();
    //store
    const { admin } = useAdminStore();

    useEffect(() => {
        (async () => {
            comnListAPI("T");//소요시간리스트API
            if (data !== null) {
                setCategory(data.CATEGORY)
            }
        })();
    }, []);
    /* ============================ 셀렉트 State ============================ */
    const [durationTime, setDurationTime] = useState(1);
    const [oilUnit, setOilUnit] = useState(1);
    /* ============================ 셀렉트 State ============================ */

    /* ============================ 사용차량추가 팝업호출 ============================ */
    const [isOpen, setOpen] = useState({ add: false });
    const onDismissHandler = (name, value) => {
        setOpen((prevState) => {
            return { ...prevState, [name]: value }
        })
    }
    /* ============================ 사용차량추가 팝업호출 ============================ */
    /* ============================ 사용차량삭제 ============================ */
    const [checkedItem, setCheckedItem] = useState([]);
    const deleteCheckedHandler = (item) => {
        const newList = checkedItem.filter(ele => ele !== item);
        setCheckedItem(newList);
    }
    /* ============================ 사용차량삭제 ============================ */
    /* ============================ 옵션 ============================ */
    const [category, setCategory] = useState(1)
    const categoryArray = [{ name: '엔진오일', value: 1 }, { name: '타이어', value: 2 }, { name: '정기점검', value: 3 }, { name: '기타', value: 4 }];
    const unit = [{ name: "개수(단위:1개)", value: 1 }, { name: "ml(단위:100ml) ", value: 2 }];
    /* ============================ 옵션 ============================ */
    /* ============================ 입력값 ============================ */
    const dataFilter = (i, type) => {
        switch (i) {
            case 0: return type === 0 ? '제품명' : type === 1 ? data?.ITEM_NAME ?? '' : type === 2 ? 'none' : null;
            case 1: return type === 0 ? '설명' : type === 2 ? 'none' : null;
            case 2: return type === 0 ? '단가' : type === 2 ? 'numeric' : null;
            case 3: return type === 0 ? '기술료' : type === 2 ? 'numeric' : null;
            case 4: return type === 0 ? '작업시간' : null;
            case 5: return type === 0 ? '타이어 구분' : null;
            case 6: return type === 0 ? '오일수' : type === 2 ? 'decimal' : null;
            case 7: return type === 0 ? '오일단위' : null;
            case 8: return type === 0 ? '오일필터명' :type === 2 ? 'none' : null;
            case 9: return type === 0 ? '오일필터가격' : type === 2 ? 'numeric' : null;
            case 10: return type === 0 ? '총 가격' : null;
        }
    }
    //총금액합산핸들러
    const setOnTotalPriceHandler = (e, type) => {//(단가 * 오일갯수(오일카테고리아닐시 default1)) + 오일필터단가 + 기술료
        if (inputRef.current.length <= 0 || (e !== null && type !== 'numeric' && type !== 'decimal')) { return; }

        if (type === 'numeric') { onNumberCommaHandler(e); }//세자리콤마핸들러
        if (type === 'decimal') { onDecimalCommaHandler(e); }//소수점세자리콤마핸들러

        const price = removeCommaHandler(inputRef.current[2]?.value ? inputRef.current[2].value : 0);
        const royalty = removeCommaHandler(inputRef.current[3]?.value ? inputRef.current[3].value : 0);
        const oilPrice = removeCommaHandler(inputRef.current[9]?.value ? inputRef.current[9].value : 0);
        const oilQuota = removeCommaHandler(inputRef.current[6]?.value ? inputRef.current[6].value : 1);
        const totPrice = Math.round((price * oilQuota) + oilPrice + royalty);//합금액 소숫점버림

        inputRef.current[10].value = totPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        onValidateHandler();
    }
    useEffect(() => {
        setOnTotalPriceHandler(null, 'text');
    }, [category]);
    /* ============================ 입력값 ============================ */
    /* ==================== validationCheck ==================== */
    const onValidateHandler = () => {
        if (checkedItem.length <= 0) { props.onValid(null, true); return; }
        for (let i = 0; i <= 2; i++) {
            if (inputRef.current[i].value.length <= 0) { props.onValid(null, true); return; }
        }
        if (inputRef.current[10].value.length <= 0) { props.onValid(null, true); return; }
        if (category === 1) {
            if (inputRef.current[6].value.length <= 0) { props.onValid(null, true); return; }
        }
        props.onValid(null, false);
    }
    useEffect(() => {
        onValidateHandler();
    }, []);

    useEffect(() => {
        onValidateHandler();
    }, [checkedItem]);
    /* ==================== validationCheck ==================== */
    /* ============================ 등록하기 ============================ */
    const isLock = useRef(false);
    const msg = type === 1 ? "등록" : "수정";
    //엔터이벤트핸들러
    const onSubmitHandler = async () => {
        // if(isLock.current) { setOnMessageHandler(3, `잠시만 기다려주세요`); return; }

        isLock.current = true;
        if (files.length <= 0) { partnerItemRegAndUpdateAPI(null); }
        else { partnerItemImgRegAPI(); }
    }
    //아이템이미지등록API
    const partnerItemImgRegAPI = async () => {
        const DATA = new FormData();
        let variables = { PARTNER_CD: params.cd, TYPE: 3 };
        DATA.append('file', files[0].file);
        DATA.append('requestDTO', new Blob([JSON.stringify(variables)]), { type: "application/json" });
        const result = await axiosMultiPartHandler(`partnerItemImgRegForPartner.do`, DATA);
        if (!result || result.message !== "SUCCESS") { setOnMessageHandler(2, `${msg} 완료되지 않았어요. 다시 시도해주세요.`); return; }
        if (result.message === "SUCCESS") {
            partnerItemRegAndUpdateAPI(result.data.SEQ_NO);
        }
    }
    //아이템등록API
    //시퀀스넘버 선언
    const seqRef = useRef(null);
    const [submitType, setSubmitType] = useState(1)
    const partnerItemRegAndUpdateAPI = async (imgCd) => {//type - 1.등록 2.수정
        let DATA = [];
        for (let i = 0; checkedItem.length > i; i++) {
            if (checkedItem[i].MODEL_CD != null) {
                DATA.push({
                    PARTNER_CD: params.cd
                    , SEQ_NO: submitType == 2 ? seqRef.current : 0
                    , ITEM_CD: (submitType == 1 ? 0 : data?.ITEM_CD)
                    , CATEGORY: category
                    , VEHICLE_CD: checkedItem[i].VEHICLE_CD
                    , ITEM_NAME: inputRef.current[0].value
                    , DESCRIPTION: inputRef.current[1] === undefined ? data?.DESCRIPTION ?? "" : inputRef.current[1].value
                    , PRICE: removeCommaHandler(inputRef.current[2].value)
                    , ROYALTY: inputRef.current[3].value.length === 0 ? 0 : removeCommaHandler(inputRef.current[3].value)
                    , DURATION_TIME: durationTime
                    , TIRE_FR: (category === 2 ? (inputRef.current[5].checked ? 1 : 2) : 0)
                    , OIL_NAME: (category === 1 ? inputRef.current[8].value : "")
                    , OIL_UNIT: (category === 1 ? oilUnit : 0)
                    , OIL_QUOTA: (category === 1 ? inputRef.current[6].value ?? 1 : 0)
                    , OIL_PRICE: (category === 1 ? inputRef.current[9].value.length == 0 ? 0 : removeCommaHandler(inputRef.current[9].value) : -1)
                    , TOT_PRICE: (removeCommaHandler(inputRef.current[10].value))
                    , IMG_CD: (imgCd !== undefined && imgCd !== null ? imgCd : (type === 1 ? 0 : data.IMG_CD ?? 0))
                    , SUBMIT_TYPE: submitType
                    , LAST_UPDATE_USER: admin.COMN_ID
                });
            }
        }
        const result = await axiosPostHandler(`partnerItemRegAndUpdateForAdmin.do`, DATA);
        setTimeout(() => { isLock.current = false; }, 500);
        if (!result || result.message !== "SUCCESS") { setOnMessageHandler(2, `${msg} 완료되지 않았어요. 다시 시도해주세요.`); return; }
        if (result.message === "SUCCESS") {
            setOnMessageHandler(1, `${msg}이 성공적으로 처리되었습니다.`);
            if (type === 1) {
                props.onClear();//데이터리셋을 위한 상위컴포넌트 리렌더링
            }
            navigator("/user/partner/" + params.cd, { replace: true });
        }
    }
    /* ============================ 등록하기 ============================ */
    /* ==================== 파트너등록차량리스트 ==================== */
    //등록차량리스트API
    const [vehicleList, setVehicleList] = useState({ list: [], option: [] });
    const partnerVehicleListAPI = async () => {
        const DATA = { PARTNER_CD: params.cd, ITEM_CD: (type === 2 ? data.ITEM_CD : 0) };
        const result = await axiosPostHandler(`partnerVehicleListByPartnerForAdmin.do`, DATA);
        if (!result || result.message !== "SUCCESS") { setOnMessageHandler(3, '차량을 등록 후 이용해주세요.'); }
        if (result.message === "SUCCESS") {
            const data = result.data.filter(ele => ele.DEL_YN !== "Y");
            if (data.length <= 0) {
                setOnMessageHandler(3, '차량을 등록 후 이용해주세요.');
            } else {
                /* ===== 옵션그룹생성 ===== */
                const newList = data.reduce((prev, now) => {
                    if (!prev.some(obj => obj.value === now.BRAND_KOR_NAME)) {
                        const row = { name: now.BRAND_KOR_NAME, value: now.BRAND_KOR_NAME };
                        prev.push(row)
                    }
                    return prev;
                }, []);
                newList.unshift({ name: '전체', value: '' });
                setVehicleList({ list: data, option: newList });
                setCheckedItem(data.filter((item) => item.VEHICLE_YN == "Y"))
            }
        }
    }
    useEffect(() => {
        if (isOpen && vehicleList.list.length <= 0) { partnerVehicleListAPI(); }//등록차량리스트API
    }, [isOpen]);
    /* ==================== 파트너등록차량리스트 ==================== */
    /* ==================== 가격설명선택API ==================== */
    //숫자 세자리자동콤마
    const initNumberCommaHandler = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    const vehiclePriceListAPI = async (item) => {
        if (item === null) {
            seqRef.current = null;
            for (let i = 1; i < 11; i++) {
                if (inputRef.current[i] !== undefined) {
                    switch (i) {
                        case 1: inputRef.current[1].value = null; break;
                        case 2: inputRef.current[2].value = null; break;
                        case 3: inputRef.current[3].value = null; break;
                        case 4: inputRef.current[4].value = 1; setDurationTime(1); break;
                        case 5: if (category == 2){inputRef.current[5].checked = true;} break;
                        case 6: if (category == 1){inputRef.current[6].value = null;} break;
                        case 7: if (category == 1){inputRef.current[7].value = 1; setOilUnit(1);} break;
                        case 8: if (category == 1){inputRef.current[8].value = null;} break;
                        case 9: if (category == 1){inputRef.current[9].value = null;} break;
                        case 10: inputRef.current[10].value = null; break;
                    }
                }
            }
            return;
        }
        const DATA = { ITEM_CD: params.item, SEQ_NO: item.SEQ_NO };
        const result = await axiosPostHandler(`partnerItemInfoListForPartner.do`, DATA);
        if (!result) { return; }
        if (result.message == "SUCCESS") {
            //result값 내 VEHICLE_CD 배열
            const resultVehicle = result.data.map(item => item.VEHICLE_CD);
            // 위 저장한 VEHICLE_CD 배열에 포함되는 모델 객체데이터
            const filterVehicle = vehicleList.list.filter((item) => resultVehicle.includes(item.VEHICLE_CD));
            //체크리스트set
            setSubmitType(2);
            setCheckedItem(filterVehicle);
            //선택한 SEQ_NO저장
            seqRef.current = item.SEQ_NO;
            for (let i = 1; i < 12; i++) {
                if (inputRef.current[i] !== undefined) {
                    switch (i) {
                        case 1: inputRef.current[1].value = result.data[0].DESCRIPTION ?? ""; break;
                        case 2: inputRef.current[2].value = result.data[0].PRICE ?? 0; break;
                        case 3: inputRef.current[3].value = result.data[0].ROYALTY ?? 0; break;
                        case 4: inputRef.current[4].value = result.data[0].DURATION_TIME ?? 1; setDurationTime(result.data[0].DURATION_TIME ?? 1); break;
                        case 5: if (category == 2) { inputRef.current[5].checked = result.data[0].TIRE_FR == 1 ? true : false; } break;
                        case 6: if (category == 1) { inputRef.current[6].value = result.data[0].OIL_QUOTA ?? 1; } break;
                        case 7: if (category == 1) { inputRef.current[7].value = result.data[0].OIL_UNIT ?? 1; setOilUnit(result.data[0].OIL_UNIT ?? 1); } break;
                        case 8: if (category == 1) { inputRef.current[8].value = result.data[0].OIL_NAME ?? ""; } break;
                        case 9: if (category == 1) { inputRef.current[9].value = result.data[0].OIL_PRICE ?? 0; } break;
                        case 10: inputRef.current[10].value = initNumberCommaHandler(result.data[0].TOT_PRICE); break;
                        case 11: if (category == 2) { inputRef.current[11].checked = result.data[0].TIRE_FR == 2 ? true : false; } break;
                    }
                }
            }
        }
    }
    /* ==================== 가격설명선택API ==================== */

    return (
        <>
            <Element tag={`div`} className={styles.formArea}>
                <Element tag={`div`} className={styles.imgArea}>
                    {type === 2 && data?.IMG_SRC !== undefined && files.length <= 0 ?
                        <Element tag={`div`} className={styles.imgPreview}>
                            <Element tag={`div`} className={styles.previewImage}><ImgArea className="imgArea" src={data.IMG_SRC} alt="preview-img" /></Element>
                            <Element tag={`label`} className={styles.currImg}>현재 이미지</Element>
                        </Element>
                        : null}
                    {/* START 이미지 추가 */}
                    {files.length < MAX_COUNT.current ?
                        <Element tag={`div`} className={styles.fileArea}>
                            <Element tag={`label`} htmlFor="file"><Element tag={`span`}>이미지 업로드</Element><FontAwesomeIcon icon="fa-light fa-rectangle-history-circle-plus" /></Element>
                            <input onChange={(e) => addFilesHandler(e)} type="file" id="file" accept='image/webp' />
                        </Element>
                        : null}
                    {files.length > 0 && files.map((file, idx) => (
                        <React.Fragment key={idx}>
                            <Element tag={`div`} className={styles.imgPreview}>
                                <Element tag={`div`} className={styles.previewImage}><img src={file.url} alt="preview-img" /></Element>
                                <Button anyprop={(e) => setFiles([])} icon={`fa-light fa-pen-to-square`} label={`이미지 변경하기`} />
                            </Element>
                        </React.Fragment>
                    ))}
                </Element>
                {/* END 이미지 추가 */}
                {/* START 사용차량추가 */}
                <FormWrapper>
                    {data !== null ? <ScrollContainer horizontal={true} component="ul">
                        <li onClick={() => { setCheckedItem([]); setSubmitType(3); vehiclePriceListAPI(null) }}>
                            <button>새로운 가격제안하기</button>
                        </li>
                        {priceGroupList && priceGroupList.length > 0 ? priceGroupList.map((item, idx) =>
                            <li key={idx} onClick={(e) => { vehiclePriceListAPI(item); }}>
                                <button>{item.DESCRIPTION + " - " + item.TOT_PRICE}</button>
                            </li>
                        ) : (<></>)}
                    </ScrollContainer> : null}
                    <TitleWrapper title={'사용 차량 :'} />
                    <ScrollContainer horizontal={true} component={`ul`} className={styles.vehicleListArea}>
                        {checkedItem.map((item, i) =>
                            <Element tag={`li`} key={i}><Element tag={`label`}>{item.BRAND_KOR_NAME + ' - ' + item.MODEL_KOR_NAME}</Element><Button anyprop={(e) => deleteCheckedHandler(item)} icon={"fa-light fa-xmark"} /></Element>
                        )}
                    </ScrollContainer>
                    <Button anyprop={(e) => onDismissHandler('add', true)} icon={"fa-light fa-circle-plus"} label={`사용 차량 추가하기`} />
                </FormWrapper>
                {/* END 사용차량추가 */}
                {/* START 카테고리선택 */}
                <FormWrapper>
                    <TitleWrapper title={'카테고리'} />
                    <Element tag={`div`} className={styles.radioArea}>
                        {categoryArray.map((item, i) =>
                            <React.Fragment key={i}>
                                <Element tag={`div`} className={["radio", styles.radio].join(" ")}>
                                    <input name="category" id={'CATEGORY_TYPE' + item.value} type="radio"
                                        onChange={(e) => setCategory(item.value)}
                                        checked={category === item.value ? true : false} />
                                    <label htmlFor={'CATEGORY_TYPE' + item.value} className="radio-label">{item.name}</label>
                                </Element>
                            </React.Fragment>
                        )}
                    </Element>
                </FormWrapper>
                {/* END 카테고리선택 */}
                {/* START 입력필드 */}
                {/* 제품명 ~ 작업시간 */}
                {[...Array(5)].map((x, i) =>
                    i !== 4 ?
                        <FormWrapper key={i}>
                            <TitleWrapper title={dataFilter(i, 0)} />
                            <input type="text" inputMode={dataFilter(i, 2)}
                                defaultValue={dataFilter(i, 1)}
                                onChange={(e) => { onValidateHandler(); setOnTotalPriceHandler(e, dataFilter(i, 2)) }}
                                ref={el => (inputRef.current[i] = el)} />
                        </FormWrapper>
                        : i === 4 && comnList.length > 0 ?
                            <Element tag={`div`} className={["formSelectArea", styles.formSelectArea].join(" ")}>
                                <TitleWrapper title={dataFilter(i, 0)} />
                                <SelectSearch options={comnList}
                                    value={durationTime}
                                    ref={el => (inputRef.current[i] = el)}
                                    onChange={(e) => { setDurationTime(e); (inputRef.current[4].value = e); }}
                                    placeholder="작업시간선택" />
                            </Element>
                            : null
                )}
                {/* 타이어구분 또는 오일명 ~ 오일가격 */}
                {[...Array(4)].map((x, i) =>
                    category === 1 ?
                        <FormWrapper key={i}>
                            <TitleWrapper title={dataFilter((i + 6), 0)} />
                            {i + 6 === 7 ?
                                <Element tag={`div`} className={["formSelectArea", styles.formSelectArea].join(" ")}>
                                    <SelectSearch options={unit}
                                        value={oilUnit}
                                        ref={el => (inputRef.current[7] = el)}
                                        onChange={(e) => { setOilUnit(e); (inputRef.current[7].value = e); }}
                                        placeholder="오일단위선택" />
                                </Element>
                                : <input type="text" inputMode={dataFilter(i + 6, 2)}
                                    ref={el => (inputRef.current[i + 6] = el)}
                                    onChange={(e) => { onValidateHandler(); setOnTotalPriceHandler(e, dataFilter(i + 6, 2)) }} />}
                        </FormWrapper>
                        : category === 2 && i === 0 ?
                            <FormWrapper key={i}>
                                <TitleWrapper title={dataFilter(5, 0)} />
                                <Element tag={`div`} className={styles.radioArea}>
                                    <Element tag={`div`} className={["radio", styles.radio].join(" ")}>
                                        <input name="tire" id={'TIRE_FR1'} type="radio"
                                            defaultChecked={true}
                                            ref={el => (inputRef.current[5] = el)} />
                                        <label htmlFor={'TIRE_FR1'} className="radio-label">앞</label>
                                    </Element>
                                    <Element tag={`div`} className={["radio", styles.radio].join(" ")}>
                                        <input name="tire" id={'TIRE_FR2'} type="radio"
                                            ref={el => (inputRef.current[11] = el)} />
                                        <label htmlFor={'TIRE_FR2'} className="radio-label">뒤</label>
                                    </Element>
                                </Element>
                            </FormWrapper>
                            : null
                )}
                {/* 총가격 */}
                <FormWrapper>
                    <TitleWrapper title={dataFilter(10, 0)} />
                    <input type="text" readOnly
                        ref={el => (inputRef.current[10] = el)}
                        placeholder="천단위 이상 등록가능." />
                </FormWrapper>
                {/* END 입력필드 */}
            </Element>
            {/* 차량선택팝업 */}
            {isOpen.add ? <VehicleListPopup isOpen={isOpen.add} checkedItem={checkedItem} setCheckedItem={setCheckedItem} vehicleList={vehicleList} onDismiss={onDismissHandler} /> : null}{/* 사용차량등록팝업 */}
        </>
    );
})
export default Form;